// extracted by mini-css-extract-plugin
export default {"logo":"logo--KWVGY","fadeSlideUp":"fadeSlideUp--wI1RF"};